import { Headline, MobileTopics, StyledTopicsSidebar, Topic } from './TopicsSidebar.styles';
import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import { buildTopicHierarchy, capitalize, predefinedSortSubTopics } from '../../../../templates/resourcesHelperFunctions';
import styled, { createGlobalStyle } from "styled-components";

// import PropTypes from 'prop-types';

const TopicsSidebar = (props) => {
  const [topicHierarchy, setTopicHierarchy] = React.useState();
  const [topicsToDisplay, setTopicsToDisplay] = React.useState([]);
  const [ topicsToDisplayAccordion, setTopicsAccordionToDisplay ] = React.useState( [] );
  const [ parentTopicSiblings, setParentTopicSiblings ] = React.useState( [] );

  React.useEffect(() => {
    let newTopicHierarchy;
    if (!topicHierarchy) {
      newTopicHierarchy = buildTopicHierarchy(props.allTopics.nodes);
      setTopicHierarchy(newTopicHierarchy);
    }
  }, [topicHierarchy, props.allTopics.nodes]);

  React.useEffect(() => {
    if (topicHierarchy) {
      let newTopicsToDisplay = [];
      topicHierarchy.forEach((ancestorTopic) => {
        if (capitalize(ancestorTopic.name) === capitalize(props.activeAncestor)) {
          if (ancestorTopic.subTopics.length > 0) {
            ancestorTopic.subTopics.forEach((topicInSubTopic) => {
              if (topicInSubTopic.subTopics?.length > 0) {
                topicInSubTopic.subTopics.forEach((topicInSubSubTopic) => {
                  newTopicsToDisplay.push({
                    topicName: topicInSubSubTopic.name
                  });
                });
              } else {
                newTopicsToDisplay.push({
                  topicName: topicInSubTopic.name
                });
              }
            });
          }
        }
      });
      setTopicsToDisplay(newTopicsToDisplay);
    }
  }, [topicHierarchy, props.activeAncestor]);

  React.useEffect( () => {
    if( topicHierarchy ) {
      let newTopicsToDisplay = [];
      topicHierarchy.forEach( ( ancestorTopic ) => {
        if( capitalize( ancestorTopic.name ) === capitalize( props.activeAncestor ) ) {
          if( ancestorTopic.subTopics.length > 0 ) {
            ancestorTopic.subTopics.forEach( ( topicInSubTopic ) => {
              if( topicInSubTopic.subTopics?.length > 0 ) {
                let subTopics = []
                topicInSubTopic.subTopics.forEach( ( topicInSubSubTopic ) => {
                  subTopics.push( {
                    topicName: topicInSubSubTopic.name,
                    name: ancestorTopic.name
                  } );
                } );
                newTopicsToDisplay.push( {
                  mainTopic: topicInSubTopic.name,
                  subTopics: subTopics,
                  name: ancestorTopic.name
                } )
              } else {
                newTopicsToDisplay.push( {
                  mainTopic: topicInSubTopic.name,
                  name: ancestorTopic.name
                } )
              }
            } );
          }
        }
      } );
      //setTopicsAccordionToDisplay( newTopicsToDisplay );

      setTopicsAccordionToDisplay( sortAccordionTopics( newTopicsToDisplay ) );
    }
  }, [ topicHierarchy, props.activeAncestor ] );

  React.useEffect( () => {
    if( props.resourceHierarchy ) {
      let topicsSiblings = [];
      props.resourceHierarchy.forEach( ( ancestorTopic ) => {
        if( capitalize( ancestorTopic.name ) === capitalize( props.activeAncestor ) ) {
          if( ancestorTopic.subTopics.length > 0 ) {
            ancestorTopic.subTopics.forEach( ( topicInSubTopic ) => {
              if( capitalize( topicInSubTopic.name ) !== capitalize( props.activeParentTopic ) ) {
                topicsSiblings.push( topicInSubTopic.name );
              }
            } );
          }
        }
      } );
      setParentTopicSiblings( topicsSiblings );
    }
  }, [ props.resourceHierarchy, props.activeAncestor, props.activeParentTopic ] );

  const changeTopic = (topicName, mainTopicName) => {
    window.location.href = `resources/?resource_parent=${encodeURIComponent( mainTopicName )}&resource_type=${encodeURIComponent( topicName )}`;
  }


  const accordionClick = ( e ) => {
    let _target = e.target,
        _parent = _target.parentElement,
        _active = _parent.getElementsByClassName( 'active-acc' )[0];

    if( _active ) {
      _active.classList.remove( 'active-acc' );
    }
    _target.classList.add( 'active-acc' );
  }

  const checkIfValidForAccordion = ( topicsAcc ) => {
    var valid = false;
    topicsAcc.map( ( topic, i ) => {
        valid = topic.subTopics?.length > 0;
    } );
    return valid();
  }


  const sortAccordionTopics = ( accordionTopics ) => {
    if( !accordionTopics || accordionTopics.length === 0  ) return accordionTopics;
    let mainTopicExists = accordionTopics[0].mainTopic;
    if( accordionTopics[0].subTopics?.length > 0 ){
      if( accordionTopics.length === 2 && accordionTopics[0].mainTopic === 'Self-Service Accounts' ) {
        let temp = accordionTopics[0];
        accordionTopics[0] = accordionTopics[1];
        accordionTopics[1] = temp;
      }

      accordionTopics.map( ( topic, i ) => {
        if( topic.subTopics ) {
          topic.subTopics = predefinedSortSubTopics( topic.mainTopic, topic.subTopics, 'topicName' );
        }
      } );

    } else if( mainTopicExists ) {
      accordionTopics = predefinedSortSubTopics( accordionTopics[0].name, accordionTopics, 'mainTopic' );
    }

    return accordionTopics;
  }

  const getTopicHTML = ( top, i ) => {
    var topicName = top.topicName === undefined ? top.mainTopic : top.topicName;
    return <Topic
        onClick={() => changeTopic( topicName, top.name )}
        key={i}
        active={capitalize( props.activeTopic ) === capitalize( topicName )}
        className={capitalize( props.activeTopic ) === capitalize( topicName ) ? ' active' : ''}
    >
                                        {topicName}
                                      </Topic>
  };

  //console.log( 'Topic sidebar::', topicsToDisplayAccordion );

  return(
      <>
      <StyledTopicsSidebar>
        {topicsToDisplay?.length > 0 &&
            <>
            {
              topicsToDisplayAccordion.map( ( topic, i ) => (
                  <>
                  {

                      topic.subTopics
                      ?
                          (
                              <>

                                <h4>{topic.mainTopic}</h4>
                                {
                      topic.subTopics ?
                          topic.subTopics.map( ( sub, i ) => {
                            return getTopicHTML( sub, i )
                          } )
                          : ''

                          }
                              </>
                          ) : getTopicHTML( topic, i )
                  }
                  </>
              ) )
            }
          </>
        }
      </StyledTopicsSidebar>
    </>
  );
}

export const AccordionContent = styled.div`

`;

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0),
    minWidth: 150,
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const MobileTopicsDropdown = (props) => {
  const classes = useStyles();
  const [topicHierarchy, setTopicHierarchy] = React.useState();
  const [topicsToDisplay, setTopicsToDisplay] = React.useState([]);
  const [selectedValue, setSelectedValue] = React.useState(props.activeTopic);

  React.useEffect(() => {
    let newTopicHierarchy;
    if (!topicHierarchy) {
      newTopicHierarchy = buildTopicHierarchy(props.allTopics.nodes);
      setTopicHierarchy(newTopicHierarchy);
    }
  }, [topicHierarchy, props.allTopics.nodes]);

  React.useEffect(() => {
    if (topicHierarchy) {
      let newTopicsToDisplay = [];
      topicHierarchy.forEach((ancestorTopic) => {
        if (capitalize(ancestorTopic.name) === capitalize(props.activeAncestor)) {
          newTopicsToDisplay.push({
            topicName: capitalize(ancestorTopic.name)
          });
          ancestorTopic.subTopics.forEach((topicInSubTopic) => {
            newTopicsToDisplay.push({
              topicName: capitalize(topicInSubTopic.name)
            });
            if (topicInSubTopic.subTopics?.length > 0) {
              topicInSubTopic.subTopics.forEach((topicInSubSubTopic) => {
                newTopicsToDisplay.push({
                  topicName: capitalize(topicInSubSubTopic.name)
                });
              });
            }
          });
        }
      });
      setTopicsToDisplay(newTopicsToDisplay);
    }
  }, [topicHierarchy, props.activeAncestor, props]);

  React.useEffect(() => {
    setSelectedValue(props.activeTopic);
  },[props])

  const handleChange = (event) => {
    const topicName = event.target.value;
    setSelectedValue(topicName);
    props.changeTopic(capitalize(topicName));
  };

  return(
    <MobileTopics>
      {topicsToDisplay &&
        <FormControl variant="outlined" className={classes.formControl}>
          {/* <InputLabel>Topic</InputLabel> */}
          <Select
            value={capitalize(selectedValue)}
            onChange={(e) => handleChange(e)}
          >
            {topicsToDisplay?.length > 0 && topicsToDisplay.map((topic, i) => (
              <MenuItem
                key={i}
                value={capitalize(topic.topicName)}
                className={'font-dropdown'}
              >
                {capitalize(topic.topicName)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      }
    </MobileTopics>
  );
}


export { TopicsSidebar, MobileTopicsDropdown };

